export type NetworkRequestStatus = 'error' | 'fetching' | 'idle' | 'success';

export type SellerScreen =
  | 'sell-splash'
  | 'sell-pcp'
  | 'sell-adoptable'
  | 'success-adoptable'
  | 'success-pcp'
  | 'update'
  | 'end-confirm'
  | 'offers'
  | 'offer-success'
  | 'progress'
  | 'invalid-deviations'
  | 'no-valid-deviations'
  | 'create-error'
  | 'generic-error'
  | 'initializing';

export interface CreateAdoptableFormValues {
  sell_as_fixed: boolean;
  purchase_price: string;
  sell_as_offer: boolean;
  allow_resale: boolean;
  early_access: boolean;
  include_original?: boolean;
  include_batch_sources: boolean;
  offer: string;
  duration: string;
  offer_delayed_start: boolean;
  accept_terms: boolean;
  necoid: string;

  // Necessary to support multiple source_url inputs with react-hook-form.
  // We'll be putting `source_url.${deviationId}` in here for each deviation
  // sent to the seller modal, and `source_files.${deviationId}` for any
  // additional assets/source files
  [key: string]: any;
}

export interface EditAdoptableFormValues {
  source_url: string;
  source_files: string;
  include_original?: boolean;
}

/**
 * All the form fields we present inside our exclusive create/resale form
 */
export enum FormField {
  SellAsFixed = 'sell_as_fixed',
  PurchasePrice = 'purchase_price',
  SellAsOffer = 'sell_as_offer',
  AllowResale = 'allow_resale',
  EarlyAccess = 'early_access',
  Offer = 'offer',
  OfferDelayedStart = 'offer_delayed_start',
  Duration = 'duration',
  AcceptTerms = 'accept_terms',
  SourceUrl = 'source_url',
  SourceFiles = 'source_files',
  IncludeBatchSources = 'include_batch_sources',
  Category = 'necoid',
}
